import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { usePageMeta } from "@/hooks/usePageMeta";
import { rupee, STATUS_LABEL } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Package, Loader2 } from "lucide-react";

export default function MyOrders() {
  usePageMeta("My Orders", "View your Nicee order history.");
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/orders/my").then(({ data }) => setOrders(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const badge = (s) =>
    s === "delivered" ? "bg-sage/10 text-sage" : s === "cancelled" ? "bg-destructive/10 text-destructive" : "bg-brand/10 text-brand";

  if (loading)
    return (
      <div className="flex min-h-[50vh] items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-brand" />
      </div>
    );

  return (
    <div className="mx-auto max-w-4xl px-4 py-12 sm:px-6">
      <h1 className="font-heading text-3xl font-bold text-ink">My Orders</h1>

      {orders.length === 0 ? (
        <div className="mt-10 rounded-2xl border border-dashed border-border bg-white/60 p-12 text-center" data-testid="my-orders-empty">
          <Package className="mx-auto h-10 w-10 text-ink-muted" />
          <p className="mt-4 font-heading text-lg text-ink">No orders yet</p>
          <Link to="/products">
            <Button className="mt-4 rounded-full bg-brand text-ink">Start shopping</Button>
          </Link>
        </div>
      ) : (
        <div className="mt-8 space-y-4">
          {orders.map((o) => (
            <div key={o.id} className="rounded-2xl border border-border/60 bg-white p-5 shadow-ambient" data-testid={`order-${o.order_number}`}>
              <div className="flex flex-wrap items-center justify-between gap-2">
                <div>
                  <p className="font-heading text-lg text-ink">{o.order_number}</p>
                  <p className="text-xs text-ink-muted">{new Date(o.created_at).toLocaleString("en-IN")}</p>
                </div>
                <span className={`rounded-full px-3 py-1 text-xs font-semibold ${badge(o.status)}`}>{STATUS_LABEL[o.status]}</span>
              </div>
              <div className="mt-3 text-sm text-ink-soft">
                {o.items.map((it, i) => (
                  <span key={i}>{it.name} ×{it.quantity}{i < o.items.length - 1 ? ", " : ""}</span>
                ))}
              </div>
              <div className="mt-3 flex items-center justify-between">
                <span className="font-semibold text-ink">{rupee(o.total)} · COD</span>
                <Link to="/track" className="text-sm font-semibold text-brand hover:underline">Track</Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
